module.exports = __webpack_public_path__ + "static/media/app_typescript.e03093a0.svg";